import request from '@/utils/request'

export function getPromotionalPlans(query) {
  return request({
    url: '/PromotionalPlans',
    method: 'get',
    params: query,
  })
}

export function patchPromotionalPlan(data) {
  return request({
    url: '/PromotionalPlans',
    method: 'patch',
    data,
  })
}

export function deletePromotionalPlan(query) {
  return request({
    url: '/PromotionalPlans',
    method: 'delete',
    params: query,
  })
}
